module.exports = __webpack_public_path__ + "static/media/hp_18.bea3c114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_18.jpg
// module id = 5829
// module chunks = 0